module.exports = __webpack_public_path__ + "img/teabig_du.830f2ca9.png";